<template>
  <master-main
    :route="getModuleRoute"
    :addProperties="{
      eventType: 1,
      routeToCreate: getModuleRoute,
    }"
    :tableProperties="tableProperties"
    :exportProperties="{
      pdf: {
        filename: `${$t('common_words.color_range')}_${dateToday}.pdf`,
        route: `${getModuleRoute}/pdf`,
      },
      xls: {
        filename: `${$t('common_words.color_range')}_${dateToday}.xlsx`,
        route: `${getModuleRoute}/excel`,
      },
    }"
    :dataBadges="[
      {
        columnLabel: $t('common_words.modules'),
        data: 'modules',
        property: 'name',
        minWidth: 200,
      },
      {
        columnLabel: $t('common_words.associated_companies2'),
        data: 'businesses',
        property: 'name',
        minWidth: 200,
      },
    ]"
    :showProperties="showProperties"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
    @refresh="refresh"
  ></master-main>
</template>
<script>
import { getDateToday } from 'src/util/Util';
import i18n from 'src/i18n';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinPermissions from 'src/util/mixinPermissions';
import RangeColorTable from 'src/views/Pages/Dashboard/RangeColor/range-color-table';
export default {
  components: { MasterMain },
  data() {
    return {
      tableProperties: {},
      showProperties: { size: '70%' },
    };
  },
  mixins: [MixinAlert, MixinLoading, MixinMain, MixinPermissions],
  computed: {
    getModuleRoute() {
      return 'rangecolors';
    },
    dateToday() {
      return getDateToday();
    },
    buildTableProperties() {
      return {
        tableColumns: [...RangeColorTable().tableColumns],
        effectTags: 'dark',
        model: 'RangeColorHeader',
        addColumns: [
          {
            label: i18n.t('common_words.modules'),
            data: 'modules',
            field: 'name',
          },
        ],
      };
    },
  },
};
</script>
